module.exports = __webpack_public_path__ + "img/learn-1-dark.759ba0d5.png";